import type { JSX } from 'react';
import { pluralize, useI18n } from '../../../i18n';
import { fill } from './remarkText';

/** «N замечания — открыть» under the title of an open thing (mockup .badge-link). */
export function RemarksBadge({ count, onOpen }: { readonly count: number; readonly onOpen: () => void }): JSX.Element | null {
  const { t, locale } = useI18n();
  if (count <= 0) return null;
  const text = locale === 'ru'
    ? pluralize(count, t('remarks.badge.one'), t('remarks.badge.few'), t('remarks.badge.many'))
    : (count === 1 ? t('remarks.badge.one') : t('remarks.badge.few'));
  return (
    <button
      type="button"
      data-testid="remarks-badge"
      className="mx-3 mt-2 self-start rounded-full border border-hl/45 px-2 py-px text-meta text-hl hover:bg-hl/10"
      onClick={onOpen}
    >
      {fill(text, { n: count })}
    </button>
  );
}
